import { types, actions } from './requests'
export const ORGANIZATION_TYPES = {
    ...types('ORGANIZATION'),
}
export const ORGANIZATION_ACTIONS = {
    ...actions('ORGANIZATION'),
}
